<template>
  <nav v-if="!loadingData">
    <v-row class="fill-height" align="center">
      <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center">
        <AlertMessages
          v-if="alertValue"
          alert-type="error"
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-card max-width="800" elevation="0" rounded="xxl" color="background">
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t("invitePeopleTitle") }}
          </v-card-title>
          <v-card-subtitle class="text-body-1 darktext--text d-none d-sm-block no-break">
            {{ $t("invitePeopleDescription") }}
          </v-card-subtitle>
          <v-form ref="form" v-model="valid">
            <v-combobox
              v-model="users"
              data-testid="user-email-input"
              :items="items"
              :placeholder="$t('addEmailsPlaceholder')"
              chips
              clearable
              solo
              class="rounded-xxl text-body-2"
              :delimiters="[',', ' ']"
              :rules="emailRules"
              multiple
              @input="checkEmailExist"
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip
                  v-bind="attrs"
                  close
                  :color="getColor(item)"
                  @click:close="remove(item)"
                >
                  <strong>{{ item.toLowerCase() }}</strong
                  >&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <v-card-subtitle class="text-body-2 greytext--text">
              {{ $t("noteInvitePeople") }}
            </v-card-subtitle>
            <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
              {{ $t("chooseRoleTitle") }}
            </v-card-title>
            <v-card-subtitle class="text-body-1 darktext--text d-none d-sm-block no-break">
              {{ $t("chooseRoleDescription") }}
            </v-card-subtitle>
            <div style="position: relative" class="mb-4">
              <v-radio-group
                v-model="chooseRoleOptions"
                class="colored-options"
                data-testid="choose-role-options"
              >
                <div style="position:relative" class="mb-4">
                  <v-radio
                    key="participant"
                    value="participant"
                    color="accent"
                    :disabled="leftSpaceMembers < 0"
                    class="black--text pa-5 option rounded-xxl mb-0"
                    data-testid="choose-role-participant"
                    active-class="selected"
                  >
                    <template v-slot:label>
                      <div>
                        <span class="text-subtitle-1 font-weight-bold">{{ $t("chooseRoleSpaceMemberOptionTitle")}}</span><br />
                        <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t("chooseRoleSpaceMemberOptionText") }}</span><br />
                        <span v-if="leftSpaceMembers > 0 && countLeftSpaceMembers > 0 && chooseRoleOptions=='participant'"
                              class="text-subtitle-2 success--text font-weight-regular">
                              {{ $tc("chooseRoleSpaceMemberOptionTextSecond",leftSpaceMembers,{ numberPeople: countLeftSpaceMembers })}}</span>
                          <span v-if="countLeftSpaceMembers == 0 && chooseRoleOptions=='participant'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleSpaceMemberOptionTextSecondError")}}</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-fade-transition>
                    <v-overlay
                      v-if="leftSpaceMembers < 0 || countLeftSpaceMembers < 0"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreSpaceMembers") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                  </v-fade-transition>
                </div>
                <div style="position:relative" class="mb-4">
                  <v-radio
                    key="booster"
                    value="booster"
                    color="accent"
                    :disabled="leftBoosters < 0"
                    class="black--text pa-5 option rounded-xxl mb-0"
                    data-testid="choose-role-booster"
                    active-class="selected"
                  >
                    <template v-slot:label>
                      <div>
                        <span class="text-subtitle-1 font-weight-bold">{{ $t("chooseRoleBoosterOptionTitle")}}</span><br />
                        <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t("chooseRoleBoosterOptionText") }}</span><br />
                        <span v-if="leftBoosters > 0 && countLeftBoosters > 0 && chooseRoleOptions=='booster'"
                              class="text-subtitle-2 success--text font-weight-regular">
                              {{$tc("chooseRoleBoosterOptionTextSecond",leftBoosters,{ numberPeople: countLeftBoosters })}}</span>
                        <span v-if="countLeftBoosters == 0 && chooseRoleOptions=='booster'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleBoosterOptionTextSecondError")}}</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-fade-transition>
                    <v-overlay
                      v-if="leftBoosters < 0 || countLeftBoosters < 0"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreBoosters") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                  </v-fade-transition>
                </div>
                <div style="position:relative" class="mb-4">
                  <v-radio
                    v-if="role == 'space_admin'"
                    key="space_admin"
                    value="space_admin"
                    color="accent"
                    :disabled="leftBoosters < 0"
                    class="black--text pa-5 option rounded-xxl mb-0"
                    data-testid="choose-role-space-admin"
                    active-class="selected"
                  >
                    <template v-slot:label>
                      <div>
                        <span class="text-subtitle-1 font-weight-bold">{{ $t("chooseRoleSpaceAdminOptionTitle") }}</span><br />
                        <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t("chooseRoleSpaceAdminOptionText") }}</span><br />
                        <span v-if="leftBoosters > 0 && countLeftBoosters > 0 && chooseRoleOptions=='space_admin'"
                              class="text-subtitle-2 success--text font-weight-regular">
                              {{$tc("chooseRoleSpaceAdminOptionTextSecond",leftBoosters,{ numberPeople: countLeftBoosters })}}</span>
                        <span v-if="countLeftBoosters == 0 && chooseRoleOptions=='space_admin'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleSpaceAdminOptionTextSecondError")}}</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-fade-transition>
                    <v-overlay
                      v-if="role == 'space_admin' && (leftBoosters < 0 || countLeftBoosters < 0)"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreSpaceAdmins") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                  </v-fade-transition>
                </div>
              </v-radio-group>
              <v-fade-transition>
                <v-overlay
                  v-if="leftSpaceMembers <= 0 && leftBoosters <= 0"
                  absolute
                  class="rounded-xxl"
                  color="white"
                >
                  <v-btn
                    ref="create"
                    data-testid="button"
                    color="accent"
                    min-width="100"
                    dark
                    elevation="0"
                    class="rounded-xxl text-none px-4"
                    @click="proceedSubmit"
                    >{{ $t("upgradePlan") }}</v-btn
                  >
                </v-overlay>
              </v-fade-transition>
            </div>
          </v-form>
        </v-card>
        <v-row no-gutters>
          <v-col align="center">
            <v-btn
              data-testid="content-access-button"
              color="accent"
              class="rounded-xxl text-none px-4"
              @click.stop="
                dialogVisible = true, 
                confirmationDialogTitle = $t('confirmationDialogShareContentOnInviteTitle'), 
                confirmationDialogText = $t('confirmationDialogShareContentOnInviteText'), 
                confirmationDialogSubmitBtn = $t('confirm')
                confirmationDialogCancelBtn = $t('cancel')"
              :disabled="!showContentAccess"
            >
              {{ $t('shareContentOnInviteBtn') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-card v-if="selectedContentConfirmed.length" max-width="800" elevation="0" color="background" class="mt-8" data-testid="content-list">
              <p class="text-body-1 darktext--text font-weight-bold mb-0" align="left">{{ $t('shareContentOnInviteList') }}</p>
              <v-list color="background">
                <v-list-item
                  v-for="item in selectedContentConfirmed"
                  :key="item.id"
                  align="left"
                >
                <v-list-item-content>
                  <v-list-item-title>
                      {{ item.attributes.title}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        <v-row no-gutters>
          <v-col align="center">
            <FormFooter
              next-button-text="invite"
              :loading="(countLeftSpaceMembers < 0 && chooseRoleOptions=='participant') || (countLeftBoosters < 0 && (chooseRoleOptions=='booster' || chooseRoleOptions=='space_admin')) ? loading == false : loading == true"
              :cancel-button-link="cancelLink"
              @proceedSubmit="invitePeople"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ConfirmationDialogShareContentOnInvite
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :content-confirmed = "selectedContentConfirmed"
      data-testid="confirmation-dialog"
      @close="dialogVisible = false"
      @selectedItems="showSelectedContentItems"
    />
  </nav>
</template>

<script>
import i18n from "../../plugins/i18n";
import {
  checkEmailExist,
  invitePeople,
  getSpaceUsersStatistics,
} from "../../api/spaceApi";
import {
  getActivitiesIsBooster
} from "../../api/activityApi";
import { getHubsIsBooster } from "../../api/hubApi";
import FormFooter from "../../components/FormFooter";
import AlertMessages from "../../components/AlertMessages";
import ConfirmationDialogShareContentOnInvite from "../../components/ConfirmationDialogShareContentOnInvite.vue"

export default {
  components: {
    FormFooter,
    AlertMessages,
    ConfirmationDialogShareContentOnInvite
  },
  data() {
    return {
      valid: true,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      status: "",
      buttonDisabled: false,
      color: "",
      value: false,
      users: [],
      items: [],
      existingUsersInSpace: [],
      spaceId: window.$cookies.get("space_id"),
      loading: false,
      emailRules: [
        (v) => {
          if (!v || v.length < 1) {
            return i18n.t("labelInputRequired");
          } else if (v.length > 0) {
            for (let i = 0; i < v.length; i++) {
             
              if (!/.+@.+/.test(v[i])) {
                return i18n.t('emailErrorValid');
              }
              //return true;
            }
            return true
          } else return true;
        },
      ],
      cancelLink: "/audiences/people",
      chooseRoleOptions: "participant",
      role: localStorage.space ? JSON.parse(localStorage.space).role : "",
      boosters: 0,
      boosters_allowed: 0,
      spaceAdmins: 0,
      spaceMembers: 0,
      statistics: {},
      leftBoosters: 0,
      leftSpaceMembers: 0,
      statisticsBoosters: 0,
      statisticsSpaceMembers: 0,
      countLeftSpaceMembers:null,
      countLeftBoosters:null,
      loadingData:false,
      dialogVisible: false,
      confirmationDialogTitle: '',
      confirmationDialogText: '',
      confirmationDialogCancelBtn: '',
      confirmationDialogSubmitBtn: '',
      selectedContentConfirmed: [],
      showContentAccess: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path != null && from.path != "/redirect") {
      next((vm) => (vm.cancelLink = from.path));
    } else {
      next();
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {
    this.loadingData = true;
    await this.getSubscriptionStatistics();
    await this.checkIfContent();
    this.loadingData = false;
  },
  methods: {
    proceedSubmit() {
      this.$router.push({path: '/space/subscription'})
    },
    remove(item) {
      this.users.splice(this.users.indexOf(item), 1);
      this.users = [...this.users];
      this.countLeftSpaceMembers = this.leftSpaceMembers - this.users.length
      this.countLeftBoosters= this.leftBoosters - this.users.length
    },
    getColor(v) {
      if (this.existingUsersInSpace.indexOf(v) >= 0) {
        return "warning";
      } else {
        if (!/.+@.+/.test(v)) {
          return "error";
        } else {
          return "accent";
        }
      }
    },
    async checkEmailExist() {
      const users = this.users.map(element => {
        return element.toLowerCase();
      });
      const lastEmail = this.users.slice().pop();
      const repeatedItems = users.filter(item => item === lastEmail.toLowerCase()).length
      if(repeatedItems > 1){
        var id = users.findIndex(item => item == lastEmail.toLowerCase());
        this.users.splice(id,1);
      }else {
        if (/.+@.+/.test(lastEmail)) {
          try {
            let data = {
              data: {
                type: "invitations",
                attributes: {
                  user_email: lastEmail,
                },
                relationships: {
                  space: {
                    data: {
                      type: "spaces",
                      id: this.spaceId,
                    },
                  },
                },
              },
            };
            const response = await checkEmailExist(data);
            if (response.status == 200) {
              this.countLeftSpaceMembers = this.leftSpaceMembers - users.length
              this.countLeftBoosters= this.leftBoosters -users.length
              return true;
            }
          } catch (e) {
            if (e.response) {
              this.existingUsersInSpace.push(lastEmail);
            }
          }
        }
      }
    },
    async invitePeople() {
      var activities= []
      var hubs = []
      for(let i = 0; i < this.selectedContentConfirmed.length; i++){
          if(this.selectedContentConfirmed[i].type == 'activities'){
            activities.push(this.selectedContentConfirmed[i].id)
          }else{
            hubs.push(this.selectedContentConfirmed[i].id)
          }
      }
      this.alertMsg = "";
      this.$refs.form.validate();
      if (this.valid) {
        this.users = this.users.map(element => {
          return element.toLowerCase();
        });
        try {
          let data = {
            data: {
              type: "invitations",
              attributes: {
                user_email: this.users,
                for_activity: activities,
                for_hub: hubs,
                for_role: this.chooseRoleOptions
              },
              relationships: {
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId,
                  },
                },
              },
            },
            meta: {
              base_url: process.env.VUE_APP_DOMAIN,
            },
          };
          const response = await invitePeople(data);
          if (response.status == 200) {
            this.$router.push({
              name: "SpaceInvites",
              params: { successfullyInvitedPeaple: true },
            });
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
          }
        }
      }
    },
    async getSubscriptionStatistics() {
      try {
        const response = await getSpaceUsersStatistics(this.spaceId);
        if (response.status == 200) {
          this.statistics = response.data.meta;
          this.statisticsBoosters = this.statistics.booster_count + this.statistics.booster_invites + this.statistics.admin_invites;
          this.statisticsSpaceMembers = this.statistics.total_members_count + this.statistics.total_invites;
          this.boosters_allowed = this.statistics.boosters_allowed;
          this.spaceMembers = this.statistics.space_members_allowed;
          this.leftBoosters = this.statistics.boosters_allowed - this.statisticsBoosters;
          this.leftSpaceMembers = this.statistics.total_allowed - this.statisticsSpaceMembers;
          this.countLeftSpaceMembers = this.leftSpaceMembers
          this.countLeftBoosters = this.leftBoosters
        }
      } catch (e) {
        if (e.response) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          this.alertValue = true;
        }
      }
    },

    showSelectedContentItems(items){
      this.selectedContentConfirmed = items
      this.dialogVisible = false
    },
    async checkIfContent(){
      const response = await getActivitiesIsBooster(this.spaceId, 1);
      if(response && response.data.meta.page.total > 0){
        this.showContentAccess = true
      }else{
        const response = await getHubsIsBooster(this.spaceId, 1);
        if(response && response.data.meta.page.total > 0){
          this.showContentAccess = true
        }
      }
    }
  },
};
</script>
<style>
.v-select--chips .v-select__slot .v-input__append-inner {
  display: none !important;
}
</style>
